export enum ReservationStatus {
  STATUS_PLANNED = 'planned',
  STATUS_CANCELLED = 'cancelled',
  STATUS_CONFIRMED = 'confirmed',
}
